module.exports = __webpack_public_path__ + "media/images/avaka_juodas-f471ec63ed97d62e7058fdfc8022b720.svg";